import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudOff16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCloudOff16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12.647 2.646a.5.5 0 1 1 .707.707l-.778.777a4.27 4.27 0 0 1 1.318 3.604A3.03 3.03 0 0 1 15 10.064c0 1.707-1.447 3.091-3.23 3.091H4.23q-.318 0-.62-.06l-1.256 1.258a.5.5 0 0 1-.708-.707zm-8.095 9.51h7.218c1.273-.001 2.23-.978 2.23-2.092 0-.612-.28-1.171-.748-1.562l-.416-.348.064-.539q.023-.19.023-.386c0-.922-.4-1.773-1.055-2.391zM9.347 2.85a4.8 4.8 0 0 1 1.465.23l-.825.824a4 4 0 0 0-.64-.053c-.909 0-1.731.318-2.358.837l-.344.286-.443-.067a2.4 2.4 0 0 0-.355-.026c-1.274 0-2.232.977-2.232 2.092q0 .136.018.265l.093.684-.608.329C2.433 8.62 2 9.307 2 10.064c0 .492.187.957.505 1.323l-.707.707A3 3 0 0 1 1 10.064c0-1.154.662-2.162 1.643-2.693a3 3 0 0 1-.028-.398c0-1.708 1.447-3.092 3.232-3.092q.257 0 .504.037A4.68 4.68 0 0 1 9.347 2.85"
            />
        </svg>
    );
}
export default memo(IconCloudOff16);
